var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPm = function SvgPm(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#343754",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.729 13.767c-.392.07-.794.105-1.197.105-4.036 0-7.31-3.53-7.31-7.88 0-1.489.402-2.943 1.131-4.186-2.894.927-4.96 3.788-4.96 7.188 0 4.14 3.122 7.505 6.962 7.505 2.1 0 4.069-1.032 5.374-2.732zm2.208-.997c-1.36 3.178-4.34 5.23-7.582 5.23C9.753 18 6 13.955 6 8.994 6 4.128 9.536.176 14.04.001c.304-.012.554.175.663.457a.796.796 0 0 1-.163.844c-1.24 1.22-1.926 2.885-1.926 4.69 0 3.518 2.655 6.38 5.918 6.38.86 0 1.687-.2 2.48-.599a.66.66 0 0 1 .784.153.799.799 0 0 1 .141.844zM9.468 25.6H7.922V28H6v-7h3.468c1.877 0 2.991.822 2.991 2.3 0 1.478-1.114 2.3-2.99 2.3zm-1.546-1.511h1.455c.774 0 1.217-.222 1.217-.789 0-.567-.443-.789-1.217-.789H7.922v1.578zM18.202 28h-1.035l-1.763-5.189h-.045V28h-1.83v-7h3.024l1.194 3.844h.034L18.952 21H22v7h-1.99v-5.189h-.046L18.202 28z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPm, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pm.9ff3ff2f.svg";
export { ForwardRef as ReactComponent };